var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({'background-color': _vm.bgcolors}),attrs:{"id":"overlay-spinner"}},[_c('div',{staticClass:"loader-spinner",style:({'border': _vm.size + 'px solid ' + _vm.objectbg,'border-top': _vm.size + 'px solid ' + _vm.object})})])}
var staticRenderFns = []

export { render, staticRenderFns }